import { z } from 'zod';

/**
 * F97 пака `tails-closeout` (WTP-B3, SOLUTION § 10.2 п. 2; К4-10) — ОДИН сборщик меток задачи.
 *
 * Сервер отдаёт у задачи `label_ids`, а имена и цвета — один раз на ответ в `label_directory`.
 * Объекты `labels` в строке уходят из выдачи (B80); тринадцать читателей (`columns/cells.tsx`,
 * `TaskRow`, `TaskCard`, календарь, доска, группировки, карточка, меню, действия) продолжают
 * читать `task.labels` — его здесь и собирают, в парсере ответа, для каждого ответа с задачей.
 *
 * `labels` в Zod — `.default([])`: без сборщика пропажа поля молча обнулила бы метки у всех задач.
 */
export const LabelDirectoryEntry = z.object({
  id: z.string(),
  name: z.string(),
  color_token: z.string(),
});
export type LabelDirectoryEntry = z.infer<typeof LabelDirectoryEntry>;

export const LabelDirectory = z.array(LabelDirectoryEntry).optional().default([]);

type WithLabels = { labels: LabelDirectoryEntry[]; label_ids?: string[] | undefined };

/**
 * Метки задачи из `label_ids` по справочнику ответа. Без `label_ids` (старый бэкенд) — как
 * пришло. Если справочник не знает какой-то id, а объекты у задачи уже есть (двухрелизный
 * период), остаются объекты: неполный справочник не должен стирать метки.
 */
export function withDirectoryLabels<T extends WithLabels>(
  task: T,
  directory: readonly LabelDirectoryEntry[],
): T {
  const ids = task.label_ids;
  if (!ids) return task;
  const byId = new Map(directory.map((l) => [l.id, l]));
  const labels = ids.map((id) => byId.get(id)).filter((l): l is LabelDirectoryEntry => !!l);
  if (labels.length < ids.length && task.labels.length > 0) return task;
  return { ...task, labels };
}
